import createReducer from "./../createReducer";
import { SettingsSections, DeviceType, IUIState } from "./types";
import { handlersUI } from "./handlers";
import { ColorPickerModes } from "./../../libs/Picker/types.d";

export const uiInitialState: IUIState = {
    settings: { isOpen: false, currentSection: SettingsSections.GENERAL },
    collaboration: { isOpen: false },
    userOptions: { isOpen: false },
    currentPopup: null,
    currentLoginPopupState: null,
    currentField: null,
    authPopUpRender: true,
    currentInputEditing: null,
    sideBar: { isOpen: true },
    isVerticalView: false,
    isPaginationActive: false,
    formBackground: {
        isStyleVisible: true,
        solid: null,
        gradient: null,
        imageUrl: null,
        lastModified: {
            type: ColorPickerModes.SOLID,
            style: "#f8f8f8",
            value: { alpha: 1, blue: 248, green: 248, hue: 0, red: 248, saturation: 0, value: 97 },
        },
    },
    logicPopup: { isOpen: false, diffX: 0, diffY: 0, leftPosition: 32, topPosition: 427, currentRuleIndex: 0 },
    mapScriptStatus: false,
    viewMode: DeviceType.DESKTOP,
};

export default createReducer(uiInitialState, handlersUI);
